import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as BaseLink } from '@medicalwebexperts/ui';

const Link = ({ ...props }) => <BaseLink as={RouterLink} {...props} />;

export default Link;
